module.exports = __webpack_public_path__ + "static/media/empireStateBuilding.62c1e888.jpg";